import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"

import { cn } from "@/lib/utils"

function Progress({
  className,
  value,
  max = 100,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root>) {
  const ceiling = Number.isFinite(max) && max > 0 ? max : 100
  const normalized =
    value == null || !Number.isFinite(value)
      ? null
      : Math.min(ceiling, Math.max(0, value))
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      value={normalized}
      max={ceiling}
      className={cn(
        "bg-primary/20 relative h-2 w-full overflow-hidden rounded-full",
        className
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className={cn(
          "bg-primary h-full flex-1 transition-all",
          normalized == null ? "w-1/3 motion-safe:animate-pulse" : "w-full"
        )}
        style={
          normalized == null
            ? undefined
            : {
                transform: `translateX(-${100 - (normalized / ceiling) * 100}%)`,
              }
        }
      />
    </ProgressPrimitive.Root>
  )
}

export { Progress }
